import { Link, useLocation } from "react-router-dom";
import { BRAND } from "@/lib/constants";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import logoImg from "@/logo.png";
import logoTextImg from "@/logo-text.png";

export default function Footer() {
  const loc = useLocation();
  if (
    loc.pathname.startsWith('/invite') ||
    loc.pathname.startsWith('/photos') ||
    loc.pathname.startsWith('/admin') ||
    loc.pathname.startsWith('/ar')
  ) {
    return null;
  }

  return (
    <footer className="relative border-t border-line mt-32 bg-ink" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img src={logoImg} alt="KV Eventech Logo" className="h-12 w-auto object-contain" />
            <img src={logoTextImg} alt="KV Eventech Text" className="h-5 w-auto object-contain" />
          </div>
          <p className="font-serif italic text-2xl leading-snug text-parchment/80 max-w-md">
            Moments that last forever — crafted with a director's eye and an artist's soul.
          </p>
          <div className="mt-8 text-xs font-display uppercase tracking-[0.3em] text-muted2">
            Est. Andhra Pradesh · India
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] font-display uppercase tracking-[0.3em] text-copper mb-5">Navigate</div>
          <ul className="space-y-3 font-sans text-sm text-parchment/70">
            <li><Link className="link-underline" to="/">Home</Link></li>
            <li><Link className="link-underline" to="/services">Services</Link></li>
            <li><Link className="link-underline" to="/gallery">Gallery</Link></li>
            <li><Link className="link-underline" to="/about">About</Link></li>
            <li><Link className="link-underline" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] font-display uppercase tracking-[0.3em] text-copper mb-5">Touch Point</div>
          <ul className="space-y-4 font-sans text-sm text-parchment/80">
            <li className="flex items-start gap-3"><Phone size={14} className="mt-0.5 text-copper" /><a href={`tel:${BRAND.phone}`} className="link-underline">{BRAND.phoneDisplay}</a></li>
            <li className="flex items-start gap-3"><Mail size={14} className="mt-0.5 text-copper" /><a href={`mailto:${BRAND.email}`} className="link-underline">{BRAND.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={14} className="mt-0.5 text-copper" />{BRAND.city}</li>
            <li className="flex items-start gap-3"><Instagram size={14} className="mt-0.5 text-copper" /><a className="link-underline" href="https://instagram.com/KV_EVENTECH" target="_blank" rel="noreferrer">@KV_EVENTECH</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3 font-display text-[10px] uppercase tracking-[0.28em] text-muted2">
          <div>© {new Date().getFullYear()} KV Eventech · All Rights Reserved</div>
          <div>Crafted for moments that matter</div>
        </div>
      </div>
    </footer>
  );
}
